/**
 * @author       yontaek@zumper.com (Yon Taek Chung)
 * @copyright    Copyright (c) 2021, Zumper
 * @description  styles.ts
 */

import { type Theme, css } from '@emotion/react'

export const formContainer = ({ colors }: Theme) => css`
  display: flex;
  justify-content: space-between;
  border-radius: 12px;
  background: ${colors.backgroundLight};
  box-shadow: 0px 16px 64px rgb(0 0 0 / 8%);
  padding: 32px;
  border-radius: 12px;
`

export const autocompleteContainer = css`
  width: 488px;
  height: 64px;
  position: relative;

  input {
    height: 64px !important;
  }
`

export const searchBtn = ({ typography }: Theme) => css`
  height: 56px;
  font-weight: ${typography?.fontWeightBold ?? 700};
  padding: 0 16px 0 24px;
`

export const searchIcon = css`
  margin-left: 24px;
`

export const longTermStyles = css`
  width: 488px;
  margin-right: 0;
`
